/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Section: Services
 */

import { Col, Container, Row } from 'react-bootstrap'

const Services = (props) => {
    const {services} = props;

    return(
        <Container>
            <Row>
                {services.map((service, idx) => {
                    return(
                        <Col 
                            key={idx}
                            md={6} lg={4}
                            className="text-center"
                            data-aos="zoom-up"
                        >
                            <div className="mt-3">
                                <div className="mb-2">
                                    <i>{service.icon}</i>
                                </div>
                                <h5 className="mb-2">{service.title}</h5>
                                <p className="text-muted mb-0">{service.text}</p>
                                
                                {service.html}

                                {service.textBullets ? 
                                    <ul className="text-start pt-2">
                                        {service.textBullets.map((bullet, idx) => {
                                            return(
                                                <li key={idx}>
                                                    <p className="text-muted mb-0">{bullet.text}</p>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                : null}
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
}

export default Services;